export interface OnboardingFlowStep {
  id: string;
  label: string;
  description: string;
  path: string;
}

export const ONBOARDING_FLOW_STEPS: OnboardingFlowStep[] = [
  {
    id: 'configure',
    label: 'Connect & configure',
    description: 'Select provider, repository, and pipeline',
    path: '/sia/onboarding',
  },
  {
    id: 'scan',
    label: 'Scan repository',
    description: 'AST analysis on selected files',
    path: '/sia/components/process-files',
  },
  {
    id: 'inventory',
    label: 'Review inventory',
    description: 'Verify scan results and finish setup',
    path: '/sia/components/onboard-inventory',
  },
];

export function isOnboardingFlowPath(pathname: string): boolean {
  return (
    pathname.startsWith('/sia/onboarding') ||
    pathname.startsWith('/sia/components/process-files') ||
    pathname.startsWith('/sia/components/onboard-inventory')
  );
}

export function getOnboardingStepIndex(pathname: string): number {
  if (pathname.startsWith('/sia/components/onboard-inventory')) {
    return 2;
  }
  if (pathname.startsWith('/sia/components/process-files')) {
    return 1;
  }
  return 0;
}
